module.exports = "/_next/static/images/Rectangle 5-fd768f7984f285c18ae52dfb9558b38b.png";